import React from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import "./DetailSearch.css";
import DetailSearchResult from "./DetailSearchResult";

const DetailSearchCommon = ({ 
    children,
    folderName,
    searchLimit,
    onChange,
    headers = [],
    currentData = [],
    currentPage,
    pageGroup,
    totalPages,
    totalCount = 0,
    setCurrentPage,
    setPageGroup,
    onSearch,
    onPageChange,
    handleDocumentView,
    isFetchingCount
 }) => {
  const navigate = useNavigate();

  return (
    <div className="detail-search-page" style={{position: "relative", paddingBottom: "10px"}}>
        <div style={{position: "sticky", top: "0", backgroundColor: "#dcf1fa", paddingTop: "30px", zIndex: "2"}}>
            <h1 className="detail-search-title">詳細検索</h1>
        </div>

        <div className="detail-search-body">
            <div className="detail-search-body1">
                <div className="detail-grid-2col">
                    <div className="form-column_custom">
                        <div className="form-row">
                            <label>フォルダ</label>
                            <input type="text" name="folder_name" value={folderName} readOnly />
                        </div>

                        <div className="form-row">
                            <label>検索方法</label>
                            <select
                                name="searchMode"
                                onChange={(e) => onChange("searchMode", e.target.value)}
                            >
                                <option value="all">すべての条件を満たす</option>
                                <option value="any">いずれかの条件を満たす</option>
                            </select>
                        </div>
                    </div>

                    <div className="form-column_custom">

                        <div className="form-row">
                            <label>検索上限数</label>
                            <select
                                name="data_limit"
                                value={searchLimit}
                                onChange={(e) => onChange("data_limit", e.target.value)}
                            >
                                {[50, 100, 200, 500, 1000, "unlimited"].map((num) => (
                                <option key={num} value={num}>
                                    {num === "unlimited" ? "無制限" : num}
                                </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    
                </div>


            </div>

            <div className="detail-search-body2">
                {children}
            </div> 
        </div>

        <div className="detail-search-footer">
            <button onClick={() => navigate(-1)} className="btn btn-back">戻る</button>
            <button type="submit" onClick={onSearch} className="btn btn-submit">表示</button>
        </div>

        {headers?.length > 0 && (
            <DetailSearchResult
                headers={headers}
                data={currentData}
                currentPage={currentPage}
                pageGroup={pageGroup}
                totalPages={totalPages}
                totalCount={totalCount}
                setCurrentPage={setCurrentPage}
                setPageGroup={setPageGroup}
                onPageChange={onPageChange}
                handleDocumentView={handleDocumentView}
                isFetchingCount={isFetchingCount}
            />
        )}


    </div>
  );
};

DetailSearchCommon.propTypes = {
  folderName: PropTypes.string,
  searchLimit: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  headers: PropTypes.array,
  currentData: PropTypes.array,
  currentPage: PropTypes.number,
  pageGroup: PropTypes.number,
  totalPages: PropTypes.number,
  setCurrentPage: PropTypes.func,
  setPageGroup: PropTypes.func,
  children: PropTypes.node,
};

export default DetailSearchCommon;
